import * as React from "react";

export const Pen = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.72421 4.78582L8.88655 3.60831L12.3917 7.11345L11.2142 11.2758C11.0499 11.8235 10.6117 12.289 10.0641 12.4533L2.42396 15L2.0132 14.6166L6.12078 10.509C6.28509 10.5912 6.47677 10.6186 6.69584 10.6186C7.40782 10.6186 8.01027 10.0435 8.01027 9.30416C8.01027 8.59218 7.40782 7.98973 6.69584 7.98973C5.95648 7.98973 5.38142 8.59218 5.38142 9.30416C5.38142 9.52323 5.4088 9.71491 5.49095 9.87922L1.38337 13.9868L1 13.576L3.5467 5.93594C3.711 5.38826 4.17653 4.95012 4.72421 4.78582ZM14.6098 3.03325C15.1301 3.52616 15.1301 4.37506 14.6098 4.89535L13.0763 6.42885L9.57115 2.92372L11.1046 1.39022C11.6249 0.869927 12.4738 0.869927 12.9667 1.39022L14.6098 3.03325Z"
    />
);
